// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:47:48.856Z
// Property: Glen Arbors Apartments (ID: 6767906449167515)
// Collections: 39 amenities, 1 floorplans (live), 22 photos, 30 POIs, 4 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167515",
  "property_external_id": "5685514",
  "property_zillow_url": "https://www.zillow.com/apartments/napoleon-oh/glen-arbors/5XqnkX/",
  "property_apartments_url": "https://www.apartments.com/glen-arbors-napoleon-oh/2dt5d39/",
  "property_google_business_url": "https://www.google.com/maps/place/2400+Glen+Arbors+Dr,+Napoleon,+OH+43545/@41.411899,-84.1361228,1777m/data=!3m2!1e3!4b1!4m6!3m5!1s0x883c37077cfb815b:0x457ba6246e207aed!8m2!3d41.411918!4d-84.136093!16s%2Fg%2F11cnchxtbn?entry=ttu&g_ep=EgoyMDI2MDUyNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58543457459",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "glen-arbors-apartments",
  "property_name": "Glen Arbors Apartments",
  "property_website_url": "https://www.glenarborsapartments.com/",
  "property_domain": "https://www.glenarborsapartments.com/",
  "property_address": "2400 Glen Arbors Dr",
  "property_full_address": "2400 Glen Arbors Dr, Napoleon, OH 43545",
  "property_address_1": "2400 Glen Arbors Dr",
  "property_address_2": null,
  "property_address_city": "Napoleon",
  "property_address_state": "OH",
  "property_address_zip_full": "43545-5613",
  "property_address_zip": "43545",
  "property_address_country": "US",
  "property_address_county": "Henry County",
  "property_neighborhood_address": "Henry County",
  "property_address_latitude": "41.411918",
  "property_address_longitude": "-84.136093",
  "property_email": "glenarbors@dietzpropertygroup.com",
  "property_phone": "(419) 592-1114",
  "property_call_tracking_phone": "419-592-1114",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://www.dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Nestled in the serene landscape of Napoleon, OH, Glen Arbors offers spacious two and three-bedroom apartments that blend comfort and convenience. Enjoy tranquil living with ample green space, pet-friendly policies, and modern amenities like fully equipped kitchens and private balconies. Affordable rates and professional management make this the perfect home.",
  "property_long_description": "**Discover Your Ideal Home at Glen Arbors in Napoleon, OH!**\n\nWelcome to Glen Arbors, where comfort meets convenience in a serene setting at the end of a dead-end road. Our stunning apartment community offers spacious two and three-bedroom floor plans designed to meet your lifestyle needs. With affordable rental rates and income restrictions in place, Glen Arbors is the perfect choice for those seeking quality living without breaking the bank.\n\nExperience the best of both worlds with our exceptional amenities that cater to your every need. Enjoy the tranquility of our expansive green space paired with ample parking for you and your guests. Our pet-friendly policy ensures that your furry friends will love it here too! You'll appreciate the convenience of on-site professional management, as well as intercom entry and key-controlled access for added peace of mind.\n\nLocated conveniently close to large industrial employers and the expressway, Glen Arbors keeps you connected while offering a peaceful retreat at home. Our fully equipped kitchens, featuring modern appliances including dishwashers, make cooking a joy. Each apartment also boasts exceptional closet space, central air and heating, and private balconies or patios—perfect for unwinding after a long day.\n\nWith laundry facilities located in every building, you’ll enjoy ultimate convenience without having to leave home. \n\nDon't miss your chance to be part of our vibrant community! Find your new home today—browse our availability or schedule a tour to visit Glen Arbors. Your perfect apartment awaits in Napoleon, OH!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e5-c6e3-77cc-a87e-178377063458.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of an apartment building with brick and siding facade, balconies, and manicured lawn.",
    "public_id": "019e46e5-c6e3-77cc-a87e-178377063458",
    "storage_key": "property/6767906449167515/019e46e5-c6e3-77cc-a87e-178377063458.webp",
    "width": 900,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "72",
  "property_year_built": "2002",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.44444444444444",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "30",
  "property_pet_restrictions": "Dogs and cats allowed (spayed/neutered), up to 30 lb each. Maximum 2 pets per unit.",
  "property_pet_policy_description": "Dogs and cats allowed (spayed/neutered), up to 30 lb each. Pet deposit: $250 per animal. Monthly pet rent: $25 per animal. Maximum 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://glenarbors.loftliving.com/",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019ef549-67b6-76d9-ae97-fb36c9ba6629.webp",
  "property_primary_logo_media": {
    "alt_text": "Glen Arbors Apartments logo",
    "public_id": "019ef549-67b6-76d9-ae97-fb36c9ba6629",
    "storage_key": "property/6767906449167515/019ef549-67b6-76d9-ae97-fb36c9ba6629.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019ef549-67b6-76d9-ae97-fb36c9ba6629.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Glen Arbors Apartments logo",
    "public_id": "019ef549-67b6-76d9-ae97-fb36c9ba6629",
    "storage_key": "property/6767906449167515/019ef549-67b6-76d9-ae97-fb36c9ba6629.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019ef549-67a6-777b-88ff-1b6d39515a37.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Glen Arbors Apartments logo",
    "public_id": "019ef549-67a6-777b-88ff-1b6d39515a37",
    "storage_key": "property/6767906449167515/019ef549-67a6-777b-88ff-1b6d39515a37.webp",
    "width": 2000,
    "height": 2000
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#757B77",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "810 - 925",
  "property_sqft_min": "810",
  "property_sqft_max": "925",
  "property_price_range": "765 - 905",
  "property_price_min": "765",
  "property_price_max": "905",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/arborglenliving/",
  "property_instagram_url": null,
  "property_twitter_url": "https://twitter.com/pre_three",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJW4H7fAc3PIgR7XogbiSme0U",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/glenburn-green-huber-heights",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Glen Arbors",
  "property_home_romance_title": "Love Where You Live: Your Ideal Home Awaits",
  "property_home_amenities_blurb": "<p>Welcome to Glen Arbors, offering affordable housing in Napoleon, OH where comfort meets convenience. Choose from spacious two- and three-bedroom floor plans nestled in a tranquil setting. Enjoy pet-friendly living, ample parking, and community amenities like private balconies, fully equipped kitchens, and professional on-site management. Your ideal home awaits!</p>",
  "property_home_floorplans_blurb": "Welcome to Glen Arbors in Napoleon, OH, where comfort meets style. Choose from our thoughtfully designed two and three-bedroom apartments, perfect for your lifestyle. With a range of spacious floor plans, you're sure to find a home that reflects your needs. Browse our available apartment homes today and envision your new life!",
  "property_home_gallery_blurb": "At Glen Arbors in Napoleon, OH, spacious two and three-bedroom apartments await you. Nestled at the end of a tranquil road, enjoy abundant green space, a fully equipped kitchen, and your private balcony or patio. With a pet-friendly atmosphere and professional management, picture yourself thriving here!",
  "property_home_neighborhood_blurb": "<p>At Glen Arbors, our affordable apartments in Napoleon, OH put you among inviting two and three-bedroom floor plans. Immerse yourself in a vibrant community, with rich local options like the Napoleon Public Library, Northwest Ohio Gymnastics, and the serene Canal Falls River Access nearby. Uncover living at its finest—your adventure starts here!</p>",
  "property_home_reviews_blurb": "At Glen Arbors in Napoleon, OH, residents rave about the welcoming atmosphere, stating, “It truly feels like home!” With modern amenities and a vibrant community, our apartments offer the perfect blend of comfort and style. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Napoleon, OH, Glen Arbors offers more than just a home. Enjoy a vibrant community with local treasures like the Napoleon Public Library, Northwest Ohio Gymnastics, and the serene Canal Falls River Access. Embrace a lifestyle filled with culture, recreation, and charm right outside your door.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Nestled at the end of a tranquil road, Glen Arbors is an affordable apartment community in Napoleon, OH offering spacious two- and three-bedroom apartments with exceptional closet space, private balconies, and fully equipped kitchens. Enjoy ample parking, pet-friendly practices, and on-site management—all while staying close to major employers and the expressway. Discover your serene retreat today!</p>",
  "property_applynow_blurb": "<p>Looking for the best affordable apartments in Napoleon, OH? At Glen Arbors, your perfect home awaits with spacious two- and three-bedroom floor plans. Nestled at the end of a tranquil road, enjoy ample green spaces, professional management, and pet-friendly living. Experience comfort with modern amenities and affordable rates—apply now to start your next chapter!</p>",
  "property_contactus_blurb": "<p>At Glen Arbors, we provide tax credit apartments in Napoleon, OH with spacious two and three-bedroom floor plans that offer a perfect blend of comfort and style. Designed for modern living, each layout promises a welcoming atmosphere. Have questions? Reach out to our leasing team today for personalized assistance and let us help you find your ideal home!</p>",
  "property_faqs_blurb": "At Glen Arbors in Napoleon, OH, we offer spacious two-bedroom and three-bedroom floor plans designed for your comfort. Have questions? Our FAQs page is a treasure trove of insights, addressing everything you need to know about our vibrant community. Uncover the answers that can help shape your new home today!",
  "property_floorplans_blurb": "<p>At Glen Arbors, our affordable two-bedroom apartments in Napoleon, OH—along with our thoughtfully designed three-bedroom floor plans—cater to your lifestyle needs. Each spacious layout offers modern amenities and a welcoming ambiance. Browse our available apartment homes today and envision the perfect space to call your own!</p>",
  "property_gallery_blurb": "<p>Glen Arbors is proud to be one of the top choices among Napoleon, OH affordable apartments. Nestled at the end of a tranquil road, enjoy abundant green space, a fully equipped kitchen, and your private balcony or patio. With a pet-friendly atmosphere and professional management, picture yourself thriving here!</p>",
  "property_interactivemap_blurb": "At Glen Arbors in Napoleon, OH, our tranquil community offers spacious two and three-bedroom apartments nestled at the end of a peaceful road. Enjoy ample parking, pet-friendly living, and exceptional amenities. Dive into our interactive community map to find your new home today—affordability and comfort await!",
  "property_pets_blurb": "<p>At Glen Arbors, our pet-friendly, affordable apartments in Napoleon, OH mean your furry friends are embraced! With a pet-friendly policy catering to dogs and cats up to 30 lbs, you can share your home with your beloved companions. Experience cozy living surrounded by nature, where every day feels like an adventure for you and your pets!</p>",
  "property_referafriend_blurb": "At Glen Arbors in Napoleon, OH, we offer spacious two and three-bedroom floor plans perfect for making lasting memories. With a welcoming atmosphere and vibrant community, you’ll love living here. Great friends make great neighbors—refer a friend to join our thriving community today!",
  "property_residentaccess_blurb": "Welcome to Glen Arbors in Napoleon, OH, where spacious two and three-bedroom floor plans await you. Stay connected to your community with seamless access to our resident portal—pay rent, schedule maintenance, and manage your lifestyle effortlessly. Unlock convenience and comfort today!",
  "property_reviews_blurb": "At Glen Arbors in Napoleon, OH, our residents rave about the sense of community and serenity. One resident highlights, “The friendly atmosphere and beautiful surroundings make everyday living a joy!” Join us to experience the warmth and comfort that Glen Arbors offers. See what our residents have to say!",
  "property_created_at": "1779305838666",
  "property_scheduletour_blurb": "<p>Tour our affordable three-bedroom apartments in Napoleon, OH—along with our inviting two-bedroom floor plans—at Glen Arbors, designed for comfort and style. Ready to envision your new home? Schedule a tour today and hear why our residents love embracing life in our vibrant community!</p>",
  "property_thankyou_blurb": "Welcome to Glen Arbors in Napoleon, OH! Our thoughtfully designed two and three-bedroom floor plans offer spacious living tailored to your lifestyle. With modern amenities and inviting community spaces, your perfect home awaits. We appreciate your interest—our team will be in touch soon to help you find your ideal apartment!",
  "property_virtualtours_blurb": "<p>Step into Glen Arbors, home to affordable two- and three-bedroom apartments in Napoleon, OH. Enjoy modern amenities and a vibrant community atmosphere. Experience it all from the comfort of your home—take a virtual tour and envision your new lifestyle today!</p>",
  "property_copyright": "2026 All Rights Reserved. Glen Arbors",
  "property_seo_title_home": "Glen Arbors Apartments | Affordable Apartments Napoleon, OH",
  "property_seo_description_home": "Affordable 2 & 3 bedroom apartments in Napoleon, OH. Private balconies, laundry facilities & on-site management. Near Walmart, Biggby Coffee & downtown Napoleon",
  "property_seo_title_floorplans": "Tax Credit 2 & 3 Bedroom Apartments in Napoleon, OH",
  "property_seo_description_floorplans": "Browse 2 & 3 bedroom floor plans at Glen Arbors Apartments in Napoleon, OH. Fully equipped kitchens, private balconies/patios, central air & closet space.",
  "property_seo_title_amenities": "Balconies, Laundry & Pet Friendly | Napoleon, OH 43545",
  "property_seo_description_amenities": "Glen Arbors Apartments offers affordable apartments with private balconies, laundry facilities, fully equipped kitchens & on-site management in Napoleon, OH.",
  "property_seo_title_gallery": "Gallery | Apartments in Napoleon, OH",
  "property_seo_description_gallery": "Discover Glen Arbors in Napoleon, OH: spacious two and three-bedroom homes, pet-friendly amenities, and serene surroundings await you!",
  "property_seo_title_virtualtours": "Virtual Tours | Glen Arbors Apartments",
  "property_seo_description_virtualtours": "Experience Glen Arbors in Napoleon, OH! Take a virtual tour of our spacious two and three-bedroom apartments—your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Glen Arbors Apartments",
  "property_seo_description_interactivemap": "Find your peaceful retreat at Glen Arbors in Napoleon, OH. Spacious two and three-bedroom apartments with amenities galore—perfect for you and your pet!",
  "property_seo_title_neighborhood": "Affordable housing Near Shopping & Dining in Napoleon OH",
  "property_seo_description_neighborhood": "Glen Arbors Apartments is minutes from Walmart, Chief Supermarkets, Biggby Coffee, Napoleon Municipal Golf Course & Fort St Joseph Museum in Napoleon, OH.",
  "property_seo_title_contact": "Contact Glen Arbors Apartments | Napoleon, OH 43545",
  "property_seo_description_contact": "Contact Glen Arbors Apartments in OH, for affordable 2 & 3 bedroom apartments, pet-friendly features, availability, and floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Napoleon, OH",
  "property_seo_description_faqs": "Find answers to your questions about Glen Arbors in Napoleon, OH. Discover our pet-friendly apartments, serene setting, and top-tier amenities today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Napoleon, OH",
  "property_seo_description_reviews": "Discover Glen Arbors in Napoleon, OH! Enjoy spacious layouts, pet-friendly perks, and glowing reviews. Find your ideal home today!",
  "property_seo_title_applynow": "Apply for an Apartment | Glen Arbors Apartments OH",
  "property_seo_description_applynow": "Ready to call Glen Arbors Apartments home in Napoleon, OH? Start your rental application online today — quick, easy & secure. Your new chapter starts here!",
  "property_seo_title_residentaccess": "Resident Access | Glen Arbors",
  "property_seo_description_residentaccess": "Login to Glen Arbors' resident portal in Napoleon, OH. Conveniently pay rent, request maintenance, and manage your home with ease—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Glen Arbors",
  "property_seo_description_referafriend": "Refer a friend to Glen Arbors in Napoleon, OH! Great friends lead to great neighbors. Join our vibrant community today for a life filled with connections!",
  "property_seo_title_scheduletour": "Schedule a Tour | Glen Arbors",
  "property_seo_description_scheduletour": "Experience the charm of Glen Arbors in Napoleon, OH! Schedule a tour today and envision your future in a welcoming community designed for you.",
  "property_seo_title_privacy": "Privacy Policy | Glen Arbors",
  "property_seo_description_privacy": "At Glen Arbors in Napoleon, OH, your privacy matters. Review our commitment to safeguarding your information and enjoy peace of mind in your new home.",
  "property_seo_title_accessibility": "Website Accessibility | Glen Arbors",
  "property_seo_description_accessibility": "At Glen Arbors in Napoleon, OH, we prioritize accessibility for all. Join us in creating an inclusive community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Glen Arbors",
  "property_seo_description_sitemap": "Find your path to comfort at Glen Arbors in Napoleon, OH. Navigate our community and amenities with ease by checking out our comprehensive sitemap today!",
  "property_seo_title_thankyou": "Thank You | Glen Arbors",
  "property_seo_description_thankyou": "Thank you for reaching out to Glen Arbors in Napoleon, OH! Expect a prompt response from our team as we help you find your perfect home with us.",
  "property_seo_title_pets": "Pet Policy | Apartments in Napoleon, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790113565450",
  "amenities": [
    {
      "id": "custom_bc752e81-3f9a-47e0-aa71-c6b9b01a0453",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57ba872e-af01-499a-a634-4dfbdcaa3805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_054df18f-ac0a-42b8-8736-1ed27d69add2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0f29d02-ee28-4bf0-a5a2-2e940a82f76f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8738881-a1ec-41f8-b9ca-8410002af59e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0bfab17-f68b-45b2-a70f-4eb2188a4602",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ee51690-d09b-4321-99f1-133cb34bdd50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76c77bdf-dcfe-4455-b8b7-3d1d783c1392",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc205b20-b0d0-4260-9fd6-b5c1285802af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e19ff3f-a94c-4488-aa03-f764ae03ccdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4fce2a08-1546-457e-be2b-dbb68edef2ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Central Heating/Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_759c8997-7662-4158-b4b8-e2b3f7a8a9a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Expressway",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2364b52-1893-43ca-9788-1890e85f8898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Income Restrictions Apply",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_962d7225-c323-4a39-812e-e69e6f9bceb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8ac84be1-b64e-4736-95f8-39194f00d523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce39ff19-494f-42f0-ac46-447291e77cdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b51bdeb8-68b0-4fef-a169-402e843a73d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Site with Ample Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_417df0ae-1b85-461c-bd01-64e9a3e8a6b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Stove/Oven",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecad7bad-3b2d-42b6-b1e3-537cf7f32b8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Tranquil Setting at End of Dead End Road",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ebe4c397-9245-4f58-93d6-54d01e38a535",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dfba309c-dd86-4c92-b09a-6232873dd5ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc09b47e-e547-48e5-81c0-ce1dfb2c7f66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_081e1e2b-32be-48f4-8b38-5e07f00a2677",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_564f4321-3eaa-4307-8367-69e217626594",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ee0221d-fba1-43b0-9524-41be6d1ff161",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Intercom",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4757697e-e324-4d18-bc51-8883abc62ed5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33b947b5-d952-4e3f-a701-c4624da8306d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_acd66fda-b6ed-437a-99ba-5d206cec7076",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce7cbabb-5ecb-4b5a-9fe3-de191a1d43be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_16981e82-24b8-4455-8924-541d3310a1c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9182677-b054-4dbb-8b8c-1bfb00dd015c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_076bf8d0-3d0a-43a2-b21f-8f238bdb2dfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9643c35b-cd64-46cf-9a95-fd127c6882d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71d28ed5-bb92-4df3-b4e6-0f4363a09574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0262bb1a-5098-4ce9-8942-b796d1a75704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9be7908-3f69-4081-9100-a7e138fd305d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3fd2bb33-7c98-4dd5-9a4f-6bf6affb886e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4074bc9d-4db9-4537-98fb-0574e580ad77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97102fc9-8071-4eb4-8b2e-25a6cb597abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony/Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_439d8f08-6aea-4d82-a7a2-50ab18689ac5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f2a-3c1b-75ad-8755-adb159742f42.webp",
      "image_media": {
        "alt_text": "Wooden playground with a yellow slide and climbing bars at Glen Arbors Apartments.",
        "public_id": "019e8f2a-3c1b-75ad-8755-adb159742f42",
        "storage_key": "property/6767906449167515/019e8f2a-3c1b-75ad-8755-adb159742f42.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a large yellow slide, climbing structures, and a picnic bench.",
      "link": "",
      "alt_text": "Wooden playground with a yellow slide and climbing bars at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b3cc91c6-42b0-4374-a587-118e88800b2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f2a-3afc-76e2-a470-3cfe59e5f5ca.webp",
      "image_media": {
        "alt_text": "Welcome Center building with American flag and signage at Glen Arbors Apartments.",
        "public_id": "019e8f2a-3afc-76e2-a470-3cfe59e5f5ca",
        "storage_key": "property/6767906449167515/019e8f2a-3afc-76e2-a470-3cfe59e5f5ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "This image shows the exterior of the Welcome Center building, complete with an American flag and clear signage directing visitors.",
      "link": "",
      "alt_text": "Welcome Center building with American flag and signage at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a5682f9-c473-4e55-8267-4bf003659d1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f2a-34cf-723b-8839-c9c8b7659984.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick and siding apartment building with balconies and green lawn at Glen Arbors Apartments.",
        "public_id": "019e8f2a-34cf-723b-8839-c9c8b7659984",
        "storage_key": "property/6767906449167515/019e8f2a-34cf-723b-8839-c9c8b7659984.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A view of the exterior of an apartment building, featuring a combination of red brick and light-colored siding. Balconies are visible on the upper floors. The building is surrounded by a neatly kept lawn and mature landscaping.",
      "link": "",
      "alt_text": "Exterior view of a brick and siding apartment building with balconies and green lawn at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42bd9fb0-f08d-408d-b6a6-ea6042f78562",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-8338-73d8-83a1-4073c7484a19.webp",
      "image_media": {
        "alt_text": "Couple enjoying a meal together in their apartment kitchen.",
        "public_id": "019f054a-8338-73d8-83a1-4073c7484a19",
        "storage_key": "property/6767906449167515/019f054a-8338-73d8-83a1-4073c7484a19.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Experience comfortable and convenient living. Enjoy shared meals and create lasting memories in your beautiful new apartment home.",
      "link": "",
      "alt_text": "Couple enjoying a meal together in their apartment kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67c60b1a-8ad6-462a-847b-bf17d53758b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f2a-22b5-772a-921a-335e68968596.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, a window with blinds, and a closet.",
        "public_id": "019e8f2a-22b5-772a-921a-335e68968596",
        "storage_key": "property/6767906449167515/019e8f2a-22b5-772a-921a-335e68968596.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This empty bedroom features neutral walls, plush carpeting, a large window with blinds for natural light, and a convenient closet for storage.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, a window with blinds, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e51d95f-2fd5-43d0-911f-303a0aa58d3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f2a-1eae-77e9-982c-b34e45d8e5a1.webp",
      "image_media": {
        "alt_text": "Playground with slides, ladders, and tires at Glen Arbors Apartments.",
        "public_id": "019e8f2a-1eae-77e9-982c-b34e45d8e5a1",
        "storage_key": "property/6767906449167515/019e8f2a-1eae-77e9-982c-b34e45d8e5a1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A fun playground area for children, featuring yellow slides, climbing structures, and tires, located within the community grounds.",
      "link": "",
      "alt_text": "Playground with slides, ladders, and tires at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_250c745c-8112-48d6-8750-79584614417e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f2a-1c5b-77ea-b471-7c17fe2b265d.webp",
      "image_media": {
        "alt_text": "Closet and vanity area in an apartment bedroom.",
        "public_id": "019e8f2a-1c5b-77ea-b471-7c17fe2b265d",
        "storage_key": "property/6767906449167515/019e8f2a-1c5b-77ea-b471-7c17fe2b265d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with sliding doors and a separate vanity area, providing ample storage and a convenient grooming space.",
      "link": "",
      "alt_text": "Closet and vanity area in an apartment bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36fa3dc5-aebe-4877-8909-0ef5572aafc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f2a-0c87-71d9-aa5d-9230d9a2a15d.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet and sliding glass door at Glen Arbors Apartments.",
        "public_id": "019e8f2a-0c87-71d9-aa5d-9230d9a2a15d",
        "storage_key": "property/6767906449167515/019e8f2a-0c87-71d9-aa5d-9230d9a2a15d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and ample natural light from the sliding glass door.",
      "link": "",
      "alt_text": "Empty living room with carpet and sliding glass door at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2f1320c-8537-4cfc-96d7-0296cb9fde5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f29-fc5c-736f-a8fa-455d34d96c3e.webp",
      "image_media": {
        "alt_text": "Bedroom with window and closet",
        "public_id": "019e8f29-fc5c-736f-a8fa-455d34d96c3e",
        "storage_key": "property/6767906449167515/019e8f29-fc5c-736f-a8fa-455d34d96c3e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a large window for natural light and a spacious closet for storage. This room provides a comfortable and functional living space.",
      "link": "",
      "alt_text": "Bedroom with window and closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2811c1f5-6495-4e87-a00e-f0334f8a6200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-9da4-73e9-8a97-e95ea48d95bc.webp",
      "image_media": {
        "alt_text": "Father lifting his laughing son in the air at Glen Arbors Apartments.",
        "public_id": "019f054a-9da4-73e9-8a97-e95ea48d95bc",
        "storage_key": "property/6767906449167515/019f054a-9da4-73e9-8a97-e95ea48d95bc.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A father lifting his son in the air, both laughing joyfully. This image evokes a sense of family, happiness, and the vibrant lifestyle offered by the community.",
      "link": "",
      "alt_text": "Father lifting his laughing son in the air at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70a8a181-41d9-464d-8e0d-14dd7bb7f061",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f29-fa8f-7598-9a9d-85798bcc4934.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with red brick and grey siding.",
        "public_id": "019e8f29-fa8f-7598-9a9d-85798bcc4934",
        "storage_key": "property/6767906449167515/019e8f29-fa8f-7598-9a9d-85798bcc4934.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring red brick and grey siding, set against a backdrop of grass and bare trees.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with red brick and grey siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e28017f-b019-4181-8889-3c9159052508",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f29-f8cc-700d-bd3e-bac964461007.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment building with balconies and a black awning over the entrance displaying unit numbers at Glen Arbors Apartments.",
        "public_id": "019e8f29-f8cc-700d-bd3e-bac964461007",
        "storage_key": "property/6767906449167515/019e8f29-f8cc-700d-bd3e-bac964461007.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming brick apartment building featuring private balconies and a welcoming entrance with clear unit number signage.",
      "link": "",
      "alt_text": "Exterior of brick apartment building with balconies and a black awning over the entrance displaying unit numbers at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_61da341f-10f2-48ff-afa1-e905694fd076",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f29-fae4-75aa-bcef-fadfc7762d06.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel sink, and white appliances.",
        "public_id": "019e8f29-fae4-75aa-bcef-fadfc7762d06",
        "storage_key": "property/6767906449167515/019e8f29-fae4-75aa-bcef-fadfc7762d06.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring dark wood cabinetry, a spacious countertop with a sink and dishwasher, and white appliances including a refrigerator and stove. Perfect for everyday cooking.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel sink, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3967e46e-66ca-4a04-887a-a7b161e0cd22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-a1a6-70a4-8941-f3bee14a712c.webp",
      "image_media": {
        "alt_text": "Two people walking a small white dog on a leash in a park at Glen Arbors Apartments",
        "public_id": "019f054a-a1a6-70a4-8941-f3bee14a712c",
        "storage_key": "property/6767906449167515/019f054a-a1a6-70a4-8941-f3bee14a712c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a walk with your furry friend in our pet-friendly community park.",
      "link": "",
      "alt_text": "Two people walking a small white dog on a leash in a park at Glen Arbors Apartments",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3aa8e1c5-2cb2-48d0-ad10-cac158691de7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f29-f52d-755e-8f6f-110ca619bb98.webp",
      "image_media": {
        "alt_text": "Glen Arbors Apartment Homes monument sign.",
        "public_id": "019e8f29-f52d-755e-8f6f-110ca619bb98",
        "storage_key": "property/6767906449167515/019e8f29-f52d-755e-8f6f-110ca619bb98.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Glen Arbors Apartment Homes. Now renting with phone number 419-592-1114.",
      "link": "",
      "alt_text": "Glen Arbors Apartment Homes monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3801e13-1f28-4a0e-b0bf-98eacd493489",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f29-f465-7668-9675-abee010686bb.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with brick and siding facade, balconies, and surrounding greenery at Glen Arbors Apartments.",
        "public_id": "019e8f29-f465-7668-9675-abee010686bb",
        "storage_key": "property/6767906449167515/019e8f29-f465-7668-9675-abee010686bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building featuring a mix of brick and siding, with private balconies and well-maintained landscaping, offering a comfortable living environment.",
      "link": "",
      "alt_text": "Exterior of apartment building with brick and siding facade, balconies, and surrounding greenery at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92ef4ad0-b930-4ffa-a182-e73d2a03f328",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e8f29-f013-7175-a9ed-ec93eec3fb25.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick and vinyl apartment building with balconies and grass in front.",
        "public_id": "019e8f29-f013-7175-a9ed-ec93eec3fb25",
        "storage_key": "property/6767906449167515/019e8f29-f013-7175-a9ed-ec93eec3fb25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An exterior view of a multi-story apartment building, featuring a mix of red brick and light-colored vinyl siding. Balconies with railings are visible on the upper floors, and well-maintained landscaping surrounds the property.",
      "link": "",
      "alt_text": "Exterior view of a brick and vinyl apartment building with balconies and grass in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73ce3555-4724-4fbb-9f7d-d9f6822271d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-8974-7349-9e39-71ec9651a46e.webp",
      "image_media": {
        "alt_text": "Woman sitting on a couch using her smartphone at Glen Arbors Apartments.",
        "public_id": "019f054a-8974-7349-9e39-71ec9651a46e",
        "storage_key": "property/6767906449167515/019f054a-8974-7349-9e39-71ec9651a46e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A young woman relaxing on a comfortable couch while browsing on her smartphone. This image captures a moment of leisure and connectivity.",
      "link": "",
      "alt_text": "Woman sitting on a couch using her smartphone at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f0a5433e-ca8f-4041-b9a7-90ce87edff0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-b412-7330-8a30-b32e5810ba55.webp",
      "image_media": {
        "alt_text": "A couple looks at a smartphone together while working on a laptop at Glen Arbors Apartments.",
        "public_id": "019f054a-b412-7330-8a30-b32e5810ba55",
        "storage_key": "property/6767906449167515/019f054a-b412-7330-8a30-b32e5810ba55.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A couple collaborates on a project, looking at a smartphone and laptop, suggesting productivity and connection within a modern living space.",
      "link": "",
      "alt_text": "A couple looks at a smartphone together while working on a laptop at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd7d048c-23af-4661-bf18-f5c619248ea0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-9d31-73d2-ae71-6fb508fc1a1d.webp",
      "image_media": {
        "alt_text": "Two young women laughing while looking at a smartphone at Glen Arbors Apartments.",
        "public_id": "019f054a-9d31-73d2-ae71-6fb508fc1a1d",
        "storage_key": "property/6767906449167515/019f054a-9d31-73d2-ae71-6fb508fc1a1d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Friends sharing a laugh over content on a mobile device, showcasing a sense of community and shared experiences.",
      "link": "",
      "alt_text": "Two young women laughing while looking at a smartphone at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_962b30ab-391c-413f-8e98-2d90d2b28a64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-91b1-774d-8c6c-8c504271768a.webp",
      "image_media": {
        "alt_text": "Man holding a mug and smiling in a well-lit apartment living room at Glen Arbors Apartments.",
        "public_id": "019f054a-91b1-774d-8c6c-8c504271768a",
        "storage_key": "property/6767906449167515/019f054a-91b1-774d-8c6c-8c504271768a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy your morning coffee in your comfortable and stylish apartment. This image captures the relaxed lifestyle available at our community.",
      "link": "",
      "alt_text": "Man holding a mug and smiling in a well-lit apartment living room at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_20244026-dbc7-4a46-9af0-a5a277a4cbb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019f054a-7d0b-768c-a6b6-0f555168629d.webp",
      "image_media": {
        "alt_text": "A man looking at a cat at Glen Arbors Apartments.",
        "public_id": "019f054a-7d0b-768c-a6b6-0f555168629d",
        "storage_key": "property/6767906449167515/019f054a-7d0b-768c-a6b6-0f555168629d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A man interacts with his cat, showcasing the pet-friendly atmosphere of the community.",
      "link": "",
      "alt_text": "A man looking at a cat at Glen Arbors Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_da23fba7-ea53-4d10-8875-17216b42a508",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Daily Grill Indian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1270 Independence Dr, Napoleon, OH 43545, USA",
      "poi_short_description": "Indian comfort food such as butter chicken masala and goat curry offered in a casual setting.",
      "poi_long_description": "Diners praise the delicious and authentic Punjabi cuisine offered at this restaurant, with highly recommended dishes including butter chicken, chicken tikka masala, and goat curry. They also frequently mention the fresh naan as a standout accompaniment.\n\nSome reviews mention the service can be nonexistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-8ce0-727e-91aa-70bc975c0b43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-8ce0-727e-91aa-70bc975c0b43",
        "storage_key": "property/6767906449167515/019e46e4-8ce0-727e-91aa-70bc975c0b43.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6087610964558761766&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daily-grill-indian-restaurant",
      "poi_latitude": "41.4147298",
      "poi_longitude": "-84.09683849999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-599-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-646bd8a085ae",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYsP8tg5PIgRJk9MMeuJe1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_c2605d47-1051-48ff-91d1-50ea254bc9fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Azul Tequila",
      "poi_type": "Restaurants",
      "poi_address": "601 E Riverview Ave, Napoleon, OH 43545, USA",
      "poi_short_description": "Fajitas, enchiladas, and other typical Mexican eats served in a casual spot with margaritas and a happy hour.",
      "poi_long_description": "Diners like this Mexican restaurant's delicious and authentic food, with many highlighting the tableside guacamole, carnitas, and Aztec soup. They also mention the friendly staff and the fun atmosphere. Others say the prices are fair and the service is fast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-8649-759b-bc33-91c7d66ccbdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-8649-759b-bc33-91c7d66ccbdd",
        "storage_key": "property/6767906449167515/019e46e4-8649-759b-bc33-91c7d66ccbdd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://azultequilaohio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1965489273563519445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "azul-tequila",
      "poi_latitude": "41.400558",
      "poi_longitude": "-84.1118025",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-599-9028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-646bd8a085ae",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRE6_m83PIgR1RmYqBTSRhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_16329c19-10dc-40b4-ba1e-a0e66e464dd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Spengler's",
      "poi_type": "Restaurants",
      "poi_address": "713 N Perry St, Napoleon, OH 43545, USA",
      "poi_short_description": "Storied pub & eatery, in operation for 135+ years, offering classic American grub & a full bar.",
      "poi_long_description": "People say this restaurant serves good breakfast, lunch, and dinner. They highlight the fair prices and generous portions. They also like the friendly staff and comfortable atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-8894-7339-af6a-c47ac78b2070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-8894-7339-af6a-c47ac78b2070",
        "storage_key": "property/6767906449167515/019e46e4-8894-7339-af6a-c47ac78b2070.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.spenglers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10690468822989060855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spenglers",
      "poi_latitude": "41.391458",
      "poi_longitude": "-84.1252154",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-592-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-646bd8a085ae",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYB-KT43PIgR97qmBMEsXJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_959960de-9d15-482a-a20a-002f7592cd66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "NINJA SUSHI HIBACHI & THAI",
      "poi_type": "Restaurants",
      "poi_address": "1425 Scott St, Napoleon, OH 43545, USA",
      "poi_short_description": "Casual Japanese and Thai eatery with a full bar specializing in sushi and hibachi dishes.",
      "poi_long_description": "This restaurant is praised for its wide variety of fresh sushi, delicious Japanese curry, and other tasty Asian cuisine, all served in generous portions. Customers also appreciate the friendly staff and the clean, unique atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-882b-777a-b83b-b58dafa009a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-882b-777a-b83b-b58dafa009a5",
        "storage_key": "property/6767906449167515/019e46e4-882b-777a-b83b-b58dafa009a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ninjaasiancuisinenapoleon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10320361786116042285&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ninja-sushi-hibachi--thai",
      "poi_latitude": "41.4013372",
      "poi_longitude": "-84.1324932",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 419-717-9664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-646bd8a085ae",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdx3YtUA3PIgRLW72Zl1KOY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_6693413b-e68c-4002-8562-81f7218eb251",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Outlaw Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "215 W Front St, Napoleon, OH 43545, USA",
      "poi_short_description": "Relaxed spot known for its smoked brisket and pulled-pork meals plus some Mexican-inspired sides and beverages.",
      "poi_long_description": "Diners like this smokehouse's delicious brisket and ribs, noting the meat is moist and falls off the bone, and they also enjoy the cheesy mac and cheese and smoky baked beans. They also highlight the generous portions and the clean, well-kept atmosphere. Guests mention the staff provides superb and friendly service, even accommodating last-minute catering requests.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-87c0-74da-97be-5298153487ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-87c0-74da-97be-5298153487ff",
        "storage_key": "property/6767906449167515/019e46e4-87c0-74da-97be-5298153487ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10555687750579070688&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "outlaw-smokehouse",
      "poi_latitude": "41.3878451",
      "poi_longitude": "-84.125092",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-592-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-646bd8a085ae",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-646bd8a085ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cc_hi43PIgR4CY1LRVWfZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8595e1bf-3c12-4267-b421-aa4ffc28be56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Chief Supermarket Napoleon",
      "poi_type": "Shopping & Retail",
      "poi_address": "1247 Scott St, Napoleon, OH 43545, USA",
      "poi_short_description": "Wide-ranging, clean supermarket chain featuring a bakery, a deli, fresh produce, meats and more.",
      "poi_long_description": "People say this grocery store offers a decent variety of products, including great ground beef, and is well-stocked. They also highlight the friendly and helpful staff, as well as the convenient in-store liquor section.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-8388-70de-8445-7b1101a2a6bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-8388-70de-8445-7b1101a2a6bc",
        "storage_key": "property/6767906449167515/019e46e4-8388-70de-8445-7b1101a2a6bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://chiefmarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16754917070369316089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chief-supermarket-napoleon",
      "poi_latitude": "41.3980566",
      "poi_longitude": "-84.1334543",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-592-2846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a838-7729-ac04-9ba6eb956a53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a838-7729-ac04-9ba6eb956a53",
        "storage_key": "property/6767906449167515/019e46e4-a838-7729-ac04-9ba6eb956a53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7T98vBA3PIgR-dx93E1sheg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_faa88027-ceef-449c-a1b5-15696698c9ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Herron's Amish Furniture and Better Sleep Gallery",
      "poi_type": "Shopping & Retail",
      "poi_address": "2250 Scott St, Napoleon, OH 43545, USA",
      "poi_short_description": "Family-owned, Amish furniture store that offers handcrafted pieces, plus mattresses.",
      "poi_long_description": "People say this furniture store offers a great selection of beautiful, high-quality furniture, including custom-made options. They also highlight the knowledgeable and helpful staff who provide excellent service without being pushy. Guests mention the reasonable prices and appreciate the professional delivery and setup services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-8cd3-72cb-93fd-61381ba533c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-8cd3-72cb-93fd-61381ba533c1",
        "storage_key": "property/6767906449167515/019e46e4-8cd3-72cb-93fd-61381ba533c1.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "https://www.herronsfurniture.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742975893227555249&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herrons-amish-furniture-and-better-sleep-gallery",
      "poi_latitude": "41.404573",
      "poi_longitude": "-84.13122779999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 419-758-3247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a841-7194-96f8-3e3071fcfa4a",
        "storage_key": "property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL2P5bZgzPIgRsck9BI2TdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_9dd91d7f-1db2-4f99-98d2-f60a5220b75b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "The Old Red Barn",
      "poi_type": "Shopping & Retail",
      "poi_address": "N 082 Co Rd 17D, Napoleon, OH 43545, USA",
      "poi_short_description": "Furniture shop selling antiques and handcrafted pieces, plus home decor and custom options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-8389-73cb-bd10-6fe1c8e3ef50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-8389-73cb-bd10-6fe1c8e3ef50",
        "storage_key": "property/6767906449167515/019e46e4-8389-73cb-bd10-6fe1c8e3ef50.webp",
        "width": 1280,
        "height": 597
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10229297294455817407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-old-red-barn",
      "poi_latitude": "41.3562842",
      "poi_longitude": "-84.2185897",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-758-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a841-7194-96f8-3e3071fcfa4a",
        "storage_key": "property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc_KXWaPNPYgRv0TnMbHD9Y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_87fd9d05-3f1c-445e-ba50-a10ddbef96a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Memory Keepers",
      "poi_type": "Shopping & Retail",
      "poi_address": "610 N Perry St, Napoleon, OH 43545, USA",
      "poi_short_description": "Store featuring an eclectic array of antiques and collectibles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-82ab-764e-bce8-bc5db5b6f9b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-82ab-764e-bce8-bc5db5b6f9b3",
        "storage_key": "property/6767906449167515/019e46e4-82ab-764e-bce8-bc5db5b6f9b3.webp",
        "width": 960,
        "height": 642
      },
      "poi_business_url": "http://www.facebook.com/memorykeepersnapoleon",
      "poi_directions_map_url": "https://maps.google.com/?cid=1758249141858883303&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memory-keepers",
      "poi_latitude": "41.390438",
      "poi_longitude": "-84.12399289999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-439-0291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a841-7194-96f8-3e3071fcfa4a",
        "storage_key": "property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUUFrwT83PIgR51YiZ0eOZhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_2f3cbd44-8f1e-4386-834f-9e1e7117cd25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Napoleon Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1255 Scott St, Napoleon, OH 43545, USA",
      "poi_short_description": "Shopping center with reviews that mention cleanliness and the parking lot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-87cf-741b-867d-dc8dffa8f278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-87cf-741b-867d-dc8dffa8f278",
        "storage_key": "property/6767906449167515/019e46e4-87cf-741b-867d-dc8dffa8f278.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11333590160093973230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "napoleon-center",
      "poi_latitude": "41.3978922",
      "poi_longitude": "-84.13328940000001",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a841-7194-96f8-3e3071fcfa4a",
        "storage_key": "property/6767906449167515/019e46e4-a841-7194-96f8-3e3071fcfa4a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe6-3CRo3PIgR7opD4jMASZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fb1da377-a1eb-4d73-9cbc-adca3acbb07e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Napoleon Public Library",
      "poi_type": "Education",
      "poi_address": "310 W Clinton St, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-900a-75ad-b53f-80e7a0928b4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-900a-75ad-b53f-80e7a0928b4f",
        "storage_key": "property/6767906449167515/019e46e4-900a-75ad-b53f-80e7a0928b4f.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.napoleon.lib.oh.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14509360304716611925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "napoleon-public-library",
      "poi_latitude": "41.3913359",
      "poi_longitude": "-84.1288904",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-592-2531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83e-732d-b203-4ec6aea7ece5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83e-732d-b203-4ec6aea7ece5",
        "storage_key": "property/6767906449167515/019e46e4-a83e-732d-b203-4ec6aea7ece5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS5Zs8j03PIgRVYHJwFKaW8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_8a41edb5-6829-439a-a865-c50b34bb6ab9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Henry County Historical Society",
      "poi_type": "Entertainment",
      "poi_address": "229 W Clinton St, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-90d5-72ad-a844-2b768222dfb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-90d5-72ad-a844-2b768222dfb5",
        "storage_key": "property/6767906449167515/019e46e4-90d5-72ad-a844-2b768222dfb5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://henrycountyhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13277305406805448715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-county-historical-society",
      "poi_latitude": "41.3909391",
      "poi_longitude": "-84.1277791",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-592-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a855-707e-9067-b5beba2f619a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a855-707e-9067-b5beba2f619a",
        "storage_key": "property/6767906449167515/019e46e4-a855-707e-9067-b5beba2f619a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJodII5j03PIgRCxgD2-t2Qrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3891787f-791a-4191-b1d0-26a098e4e06f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Napoleon Veterinary Clinic Inc",
      "poi_type": "Health and Wellness",
      "poi_address": "645 American Rd, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-90c7-7042-a6c9-b1a60890c1b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-90c7-7042-a6c9-b1a60890c1b2",
        "storage_key": "property/6767906449167515/019e46e4-90c7-7042-a6c9-b1a60890c1b2.webp",
        "width": 960,
        "height": 717
      },
      "poi_business_url": "http://www.napoleonvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3834915774106341833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "napoleon-veterinary-clinic-inc",
      "poi_latitude": "41.4167391",
      "poi_longitude": "-84.11179829999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-592-6876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_SwNJIQ3PIgRyZEmC5RbODU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9768b0c7-9bd2-4cd8-b7c3-fd44e890edf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Northwest Ohio Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "711 Glenwood Ave, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://nwoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11894095837497291276&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northwest-ohio-gymnastics",
      "poi_latitude": "41.3888068",
      "poi_longitude": "-84.1416923",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-592-0122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83e-732d-b203-4ec6aea7ece5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83e-732d-b203-4ec6aea7ece5",
        "storage_key": "property/6767906449167515/019e46e4-a83e-732d-b203-4ec6aea7ece5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45CW2yA3PIgRDHJ6hiVREKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_297b2a4d-63d2-4e38-8b78-f2e7af1509fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1412 Scott St, Napoleon, OH 43545, USA",
      "poi_short_description": "Gym chain offering 24-hour access, plus personal training and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-943b-740f-8b39-1cec9651eebb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-943b-740f-8b39-1cec9651eebb",
        "storage_key": "property/6767906449167515/019e46e4-943b-740f-8b39-1cec9651eebb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/napoleon-ohio-4728/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4728",
      "poi_directions_map_url": "https://maps.google.com/?cid=9603928699517606598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "41.4001913",
      "poi_longitude": "-84.1316988",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-573-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcSByvM3PIgRxhrttkQCSIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_44e3f6b6-0be0-4ad2-a8a0-63113a78be73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Legends barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "510 Appian Ave, Napoleon, OH 43545, USA",
      "poi_short_description": "Classic barbershop providing haircuts for children and adults with no appointments needed.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-943c-763e-ab35-245c13d1a82a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-943c-763e-ab35-245c13d1a82a",
        "storage_key": "property/6767906449167515/019e46e4-943c-763e-ab35-245c13d1a82a.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2593916102646082060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legends-barbershop",
      "poi_latitude": "41.3850619",
      "poi_longitude": "-84.11470589999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-906-5052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWr-ZUQ3PIgRDKpiw_Nw_yM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_21b77d5a-eba4-4038-a312-d3996681430c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Kay's Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "828 N Perry St, Napoleon, OH 43545, USA",
      "poi_short_description": "Nail salon offering acrylic and ombre nail services in an environment with friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-95c6-7691-a4e5-0d28246e796e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-95c6-7691-a4e5-0d28246e796e",
        "storage_key": "property/6767906449167515/019e46e4-95c6-7691-a4e5-0d28246e796e.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://hanna-nailsandspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15482553642094275540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kays-nails",
      "poi_latitude": "41.392732",
      "poi_longitude": "-84.1258893",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-592-9199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfwXngBU3PIgR1Kv15IEU3dY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_3ce5f711-5ad1-42d3-9a04-c1f654ba8f39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Salon 424",
      "poi_type": "Health and Wellness",
      "poi_address": "305 E Riverview Ave, Napoleon, OH 43545, USA",
      "poi_short_description": "Salon providing hair and nail services, along with an option for tattoos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-9719-779a-964c-b43aed393ac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-9719-779a-964c-b43aed393ac5",
        "storage_key": "property/6767906449167515/019e46e4-9719-779a-964c-b43aed393ac5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/Salon424/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2907441460837050616&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salon-424",
      "poi_latitude": "41.3919219",
      "poi_longitude": "-84.1210327",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-591-1451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFROavmo3PIgR-GhvtppOWSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_1912c046-55fe-4bfa-bacb-0eaec3c2e7a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Cost Cutters",
      "poi_type": "Health and Wellness",
      "poi_address": "1835 Scott St, Napoleon, OH 43545, USA",
      "poi_short_description": "Chain hair salon offering cuts, styling, and coloring, as well as kid-friendly services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-951f-749e-98fb-52f25eb2b5de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-951f-749e-98fb-52f25eb2b5de",
        "storage_key": "property/6767906449167515/019e46e4-951f-749e-98fb-52f25eb2b5de.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costcutters.com/locations/nearme/haircut/oh/napoleon/1835-scott-st/15747",
      "poi_directions_map_url": "https://maps.google.com/?cid=13299016508494001680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cost-cutters",
      "poi_latitude": "41.40482859999999",
      "poi_longitude": "-84.1344448",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 419-592-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgXBHExA3PIgREDbXog2Zj7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_54e7021f-47b9-4157-a09d-a25382e06dd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Wildcat",
      "poi_type": "Health and Wellness",
      "poi_address": "1225 Scott St, Napoleon, OH 43545, USA",
      "poi_short_description": "Appointments are recommended at this barber shop offering haircuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-97bf-717e-87d4-568ca761ddb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-97bf-717e-87d4-568ca761ddb4",
        "storage_key": "property/6767906449167515/019e46e4-97bf-717e-87d4-568ca761ddb4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://wildcat-barber.keeq.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1885391782182777645&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat",
      "poi_latitude": "41.3975306",
      "poi_longitude": "-84.1326701",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-592-4339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQobphA3PIgRLfNxL9ZBKho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_aa98b5fe-d701-4258-b72b-8fca81bdb5d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Wildcat Nutrition and Fitness Center (Formally Frucheys Gym)",
      "poi_type": "Health and Wellness",
      "poi_address": "620 Trail Dr, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-9839-7643-9f1d-38993093d2fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-9839-7643-9f1d-38993093d2fd",
        "storage_key": "property/6767906449167515/019e46e4-9839-7643-9f1d-38993093d2fd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.wildcatnutritionandfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3848865952807297114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-nutrition-and-fitness-center-formally-frucheys-gym",
      "poi_latitude": "41.4019239",
      "poi_longitude": "-84.133578",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 419-277-2817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhTW6sho3PIgRWqAsITHraTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_16a39b05-d690-478a-adde-6306fd128862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Jeffrey",
      "poi_type": "Health and Wellness",
      "poi_address": "136 W Washington St, Napoleon, OH 43545, USA",
      "poi_short_description": "Sporty venue for cuts and beard trims, plus a vintage Galaga arcade cabinet to play while waiting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-996c-730a-a811-09c2cb908978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-996c-730a-a811-09c2cb908978",
        "storage_key": "property/6767906449167515/019e46e4-996c-730a-a811-09c2cb908978.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/offthetopbarbershopnapoleon/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17037986532594713106&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jeffrey",
      "poi_latitude": "41.3908233",
      "poi_longitude": "-84.1260681",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-966-8162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuYMKPD43PIgREoIy83oWc-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_25be2c9c-2563-4a6b-be77-bb22ba0f46c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Henry County Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 E Riverview Ave, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-99eb-7569-b8db-f6b772f33929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-99eb-7569-b8db-f6b772f33929",
        "storage_key": "property/6767906449167515/019e46e4-99eb-7569-b8db-f6b772f33929.webp",
        "width": 1280,
        "height": 441
      },
      "poi_business_url": "http://www.henrycountyhospital.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4283387949116934519&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-county-hospital",
      "poi_latitude": "41.41119279999999",
      "poi_longitude": "-84.08780879999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-592-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83a-772b-bd47-cc6d433b50ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83a-772b-bd47-cc6d433b50ec",
        "storage_key": "property/6767906449167515/019e46e4-a83a-772b-bd47-cc6d433b50ec.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0jJFjM4PIgRd8lNNqWmcTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_3cbdf6f5-3668-47e1-bb97-68ee00350557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Napoleon Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "521 Glenwood Ave, Napoleon, OH 43545, USA",
      "poi_short_description": "Well-maintained 9-hole golf course with hilly, tree-lined greens, plus a clubhouse and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-9a87-70b9-9741-ef9b06ca227e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-9a87-70b9-9741-ef9b06ca227e",
        "storage_key": "property/6767906449167515/019e46e4-9a87-70b9-9741-ef9b06ca227e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.napoleonohio.com/departments/parks-and-recreation/municipal-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=17533342963004895059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "napoleon-golf-club",
      "poi_latitude": "41.3868231",
      "poi_longitude": "-84.1423737",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-592-5526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a889-73f5-9935-6d2437486c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a889-73f5-9935-6d2437486c7d",
        "storage_key": "property/6767906449167515/019e46e4-a889-73f5-9935-6d2437486c7d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0T44JCc3PIgRU28Ae4fyUvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_3346d030-182e-4952-ad27-b03d6f18e23c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Oakwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1398 Oakwood Ave #1396, Napoleon, OH 43545, USA",
      "poi_short_description": "Park-like complex, surrounded by woods and featuring sports fields + trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-9ce1-72fa-926a-7e07f90f422e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-9ce1-72fa-926a-7e07f90f422e",
        "storage_key": "property/6767906449167515/019e46e4-9ce1-72fa-926a-7e07f90f422e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13874369442222114349&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oakwood-park",
      "poi_latitude": "41.401606",
      "poi_longitude": "-84.1225022",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-61a6a73a3447",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdJmqhI3PIgRLQYvhn-pi8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a50fa789-7254-438e-a187-446177d7d063",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Day Light Falls",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16559 OH-424, Napoleon, OH 43545, USA",
      "poi_short_description": "Dam featuring graffiti and an easy, scenic trail for hiking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a072-75a9-ae17-759709340511.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-a072-75a9-ae17-759709340511",
        "storage_key": "property/6767906449167515/019e46e4-a072-75a9-ae17-759709340511.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132755325660045408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "day-light-falls",
      "poi_latitude": "41.3319603",
      "poi_longitude": "-84.18188599999999",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-61a6a73a3447",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c-0Q4IxPIgRYCDqdUjHnow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2a479919-2895-4d7c-9039-014cfebae626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Oberhaus Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "750 W Maumee Ave, Napoleon, OH 43545, USA",
      "poi_short_description": "Park with a public restroom, picnic tables, and a barbecue grill, plus a playground and rentals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-9e85-7413-be85-e7f29364a39a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-9e85-7413-be85-e7f29364a39a",
        "storage_key": "property/6767906449167515/019e46e4-9e85-7413-be85-e7f29364a39a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.napoleonohio.com/departments/parks-and-recreation/shelter-houses",
      "poi_directions_map_url": "https://maps.google.com/?cid=6291868486932392033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oberhaus-park",
      "poi_latitude": "41.3798989",
      "poi_longitude": "-84.13425199999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-592-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-61a6a73a3447",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSHkyS83PIgRYWgUmQ01UVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1078ee06-7a04-43b1-ab42-a4f1b0ab1860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Canal Falls River Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16747-16559, OH-424, Napoleon, OH 43545, USA",
      "poi_short_description": "Walkable trail for seeing waterfalls, the world's smallest damn and a graffiti-covered bridge.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-9e66-72ed-968a-5172efe0b751.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-9e66-72ed-968a-5172efe0b751",
        "storage_key": "property/6767906449167515/019e46e4-9e66-72ed-968a-5172efe0b751.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=732493322732305186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "canal-falls-river-access",
      "poi_latitude": "41.332194",
      "poi_longitude": "-84.18189799999999",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a886-7339-827d-61a6a73a3447",
        "storage_key": "property/6767906449167515/019e46e4-a886-7339-827d-61a6a73a3447.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkc_o0xcxPIgRIvvNzctWKgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_56d9025a-f94c-44d8-856a-8d64fe125356",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Jac Products",
      "poi_type": "Major Employers & Offices",
      "poi_address": "620 Independence Dr, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-9f98-704c-a78f-15ef3a962591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-9f98-704c-a78f-15ef3a962591",
        "storage_key": "property/6767906449167515/019e46e4-9f98-704c-a78f-15ef3a962591.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3128222608707280755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jac-products",
      "poi_latitude": "41.4105774",
      "poi_longitude": "-84.1114683",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOQ7aT7Q3PIgRc99XeuOtaSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_955688e9-f0d0-43a1-ad40-1a2772be930b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "custom",
      "poi_name": "Campbell's",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10-773 OH-110, Napoleon, OH 43545, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a278-766d-9b3a-a2dbbd417eaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-a278-766d-9b3a-a2dbbd417eaf",
        "storage_key": "property/6767906449167515/019e46e4-a278-766d-9b3a-a2dbbd417eaf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11774188950128723181&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "campbells",
      "poi_latitude": "41.395105",
      "poi_longitude": "-84.1099452",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-a83b-743c-8a6b-dae5d08c79c8",
        "storage_key": "property/6767906449167515/019e46e4-a83b-743c-8a6b-dae5d08c79c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZapMcWY3PIgR7YTAwndSZqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_87203c0a-9b1c-4e9b-af45-94aef19f2e89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "16:30"
    },
    {
      "id": "custom_47c27e2e-81c1-40a2-9108-3c0d7ac4b546",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "16:30"
    },
    {
      "id": "custom_b21c0740-9e33-4e65-8ac3-f12bd2063164",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "16:30"
    },
    {
      "id": "custom_ad362e6d-f253-4d2d-ad92-d499ba762117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "16:30"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ed0ea-ca8a-73c9-ab94-45643a9a870e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Glen Arbors Apartments Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515"
    },
    {
      "lead_collector_id": "019ed0ea-cb39-760d-9beb-f2bda2c446ed",
      "lead_source": "LANDING_PAGE",
      "name": "Glen Arbors Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-napoleon-oh",
      "search_query": "pet friendly apartments Napoleon OH",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Napoleon, OH",
      "h2_subtitle": "Discover pet friendly living in Napoleon. Glen Arbors offers a welcoming environment for you and your furry friends with top-notch amenities.",
      "page_copy": "Nestled at the end of a tranquil dead-end road, Glen Arbors is the perfect choice for those seeking pet friendly apartments in Napoleon, OH. Our community warmly welcomes furry companions, making it easier than ever to bring along your beloved pet. With central air and heating, your apartment will always be a comfortable retreat year-round.\n\nIn addition to our pet-friendly policy, Glen Arbors features convenient amenities like a laundry facility in each building, ensuring you never have to travel far for clean clothes. Plus, our close proximity to large industrial employers offers a prime location for professionals. Enjoy the peace and serenity of Glen Arbors while staying connected to the vibrant city life of Napoleon, OH.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Napoleon, OH",
      "seo_description": "Find pet friendly apartments in Napoleon, OH at Glen Arbors. Enjoy tranquil living with great amenities near industrial employers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-henry-county",
      "search_query": "apartments with dishwashers in Henry County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Henry County",
      "h2_subtitle": "Explore the convenience of apartments with dishwashers in Henry County. Glen Arbors offers a serene setting and top amenities for comfortable living.",
      "page_copy": "If you're looking for apartments with dishwashers in Henry County, consider Glen Arbors. While we focus on comprehensive in-home features, we also ensure a comfortable living experience with essential amenities such as central air and heating. Located at the end of a peaceful dead-end road, our community offers a tranquil atmosphere perfect for relaxation.\n\nGlen Arbors is not only well-suited for those needing modern conveniences, but it is also pet friendly, making it an ideal choice for pet owners. Each building comes equipped with a laundry facility, adding to the convenience of daily living. Enjoy proximity to major industrial employers while residing in a serene environment that's hard to match.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers - Henry County",
      "seo_description": "Discover apartments with dishwashers in Henry County at Glen Arbors, where you enjoy peaceful living and essential amenities like central air and heating.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "napoleon-oh-apartments-with-central-air",
      "search_query": "Napoleon OH apartments with central air",
      "category": "Amenity",
      "h1_title": "Napoleon OH Apartments with Central Air",
      "h2_subtitle": "Experience comfortable apartments with central air in Napoleon, OH. Glen Arbors offers a serene setting and superb amenities.",
      "page_copy": "At Glen Arbors, find Napoleon OH apartments with central air, ensuring you're comfortable through every season. Our community provides a peaceful living experience at the end of a serene dead-end road, ideal for those seeking tranquility.\n\nOffering a pet-friendly environment, Glen Arbors caters to residents who cherish their furry companions. Alongside central air, each building is equipped with a convenient laundry facility, adding to the ease of everyday life. Being in close proximity to major industrial employers also ensures an excellent location within Napoleon, OH—making Glen Arbors not just a place to live, but a place to thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Napoleon OH Apartments with Central Air",
      "seo_description": "Explore Napoleon OH apartments with central air at Glen Arbors, providing pet-friendly living and serene surroundings near major employers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "apartments-with-private-balconies-oh-43545",
      "search_query": "apartments with private balconies OH 43545",
      "category": "Amenity",
      "h1_title": "Apartments with Private Balconies OH 43545",
      "h2_subtitle": "Discover apartments with private balconies in OH 43545. Glen Arbors provides a peaceful living experience with excellent amenities.",
      "page_copy": "While Glen Arbors offers a variety of attractive amenities, those searching for apartments with private balconies in OH 43545 will find a serene haven here. Set at the end of a tranquil dead-end road, our community brings a sense of calm, ideal for those seeking a peaceful escape.\n\nResidents appreciate our pet-friendly policy, central air, and convenient laundry facilities located in each building. Our location is also perfect for those working at large industrial employers in the area. Experience the blend of comfort, convenience, and community at Glen Arbors, your ideal home in OH 43545.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Private Balconies OH 43545",
      "seo_description": "Find apartments with private balconies in OH 43545 at Glen Arbors, offering a serene living environment with top-notch amenities and pet-friendly options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "affordable-apartments-near-expressway-napoleon",
      "search_query": "affordable apartments near expressway Napoleon",
      "category": "Amenity",
      "h1_title": "Affordable Apartments Near Expressway Napoleon",
      "h2_subtitle": "Find affordable apartments near the expressway in Napoleon. Glen Arbors offers both value and convenience in a tranquil setting.",
      "page_copy": "For those searching for affordable apartments near the expressway in Napoleon, Glen Arbors presents an ideal option. Nestled at the end of a peaceful dead-end road, our community offers a calming retreat while maintaining convenient access to major thoroughfares.\n\nGlen Arbors features amenities like central air and heating, and every building includes a laundry facility, making day-to-day life convenient for all residents. Our pet-friendly policy ensures that both you and your furry friends feel at home. Plus, being close to large industrial employers enhances the value of choosing to live at Glen Arbors in Napoleon.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Affordable Apartments Near Expressway, Napoleon",
      "seo_description": "Discover affordable living near the expressway in Napoleon at Glen Arbors. Enjoy tranquility and top amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-napoleon-oh",
      "search_query": "two bedroom apartments Napoleon OH",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Napoleon, OH",
      "h2_subtitle": "Explore two bedroom apartments in Napoleon, OH at Glen Arbors, offering spacious layouts and comfortable living.",
      "page_copy": "Glen Arbors provides wonderful options for those seeking two bedroom apartments in Napoleon, OH. Our spacious layouts ensure ample room for both relaxation and functionality within a tranquil setting at the end of a peaceful cul-de-sac.\n\nResidents at Glen Arbors enjoy a range of amenities, including central air and heating, which ensures year-round comfort. Our community is pet-friendly, allowing your furry companions to enjoy the comfort of home, too. Additionally, every building includes a laundry facility, enhancing convenience while living close to large industrial employers in the area. Experience the best of Napoleon, OH living at Glen Arbors.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Napoleon, OH",
      "seo_description": "Find spacious two bedroom apartments in Napoleon, OH at Glen Arbors. Enjoy modern amenities and a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-henry-county",
      "search_query": "three bedroom apartments Henry County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Henry County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Henry County at Glen Arbors. Enjoy the blend of comfort and convenience.",
      "page_copy": "If you're on the hunt for three bedroom apartments in Henry County, Glen Arbors offers an ideal blend of space and comfort. Located at the tranquil end of a dead-end road, our community provides a serene retreat from the bustle of daily life.\n\nOur pet-friendly policy, combined with amenities such as central air and heating, ensures a comfortable living experience. Each building is equipped with a laundry facility, adding an extra layer of convenience. Glen Arbors is situated near major industrial employers, making it a perfect choice for professionals looking to balance work and home life in Henry County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Henry County",
      "seo_description": "Explore three bedroom apartments in Henry County at Glen Arbors. Perfect for comfort and convenience, located in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "apartments-near-oakwood-park-napoleon",
      "search_query": "apartments near Oakwood Park Napoleon",
      "category": "Park",
      "h1_title": "Apartments Near Oakwood Park, Napoleon",
      "h2_subtitle": "Live near Oakwood Park in Napoleon at Glen Arbors. Our community offers a serene retreat just minutes from local attractions.",
      "page_copy": "Looking for apartments near Oakwood Park in Napoleon? Glen Arbors offers an ideal location just minutes away. Nestled at the end of a quiet dead-end road, our community provides a peaceful setting while keeping you close to all the local attractions.\n\nEnjoy the convenience of central air and heating, ensuring comfort throughout the year. Pet-friendly policies make it easy to bring along your four-legged family members. Each of our buildings includes a laundry facility, providing added convenience. Discover the perfect blend of tranquility and accessibility by choosing Glen Arbors as your home near Oakwood Park in Napoleon.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oakwood Park, Napoleon",
      "seo_description": "Discover Glen Arbors, just minutes from Oakwood Park in Napoleon. Enjoy a peaceful, convenient living environment with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "napoleon-oh-apartments-close-to-day-light-falls",
      "search_query": "Napoleon OH apartments close to Day Light Falls",
      "category": "Park",
      "h1_title": "Napoleon, OH Apartments Close to Day Light Falls",
      "h2_subtitle": "Find apartments close to Day Light Falls in Napoleon, OH. Glen Arbors offers comfort and proximity to local attractions.",
      "page_copy": "Located conveniently close to Day Light Falls, Glen Arbors provides excellent apartment living in Napoleon, OH. Our community is perfectly positioned for those who love access to local scenic spots while enjoying a peaceful home setting.\n\nAt Glen Arbors, each apartment is equipped with central air and heating, ensuring a comfortable environment throughout the seasons. Our pet-friendly approach and accessible laundry facilities in each building make everyday life more convenient. Enjoy living near Day Light Falls at Glen Arbors, where tranquility meets accessibility in Napoleon, OH.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Napoleon, OH Apartments Near Day Light Falls",
      "seo_description": "Discover Glen Arbors, offering apartments close to Day Light Falls in Napoleon, OH. Enjoy comfort and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167515",
      "source": "generator",
      "page_item_url": "glen-arbors-henry-county-apartments-near-oberhaus-park",
      "search_query": "Glen Arbors Henry County apartments near Oberhaus Park",
      "category": "Park",
      "h1_title": "Glen Arbors Apartments Near Oberhaus Park",
      "h2_subtitle": "Explore Glen Arbors, Henry County apartments near Oberhaus Park. Enjoy the perfect blend of ease and serenity.",
      "page_copy": "Glen Arbors is the ideal choice for those seeking Henry County apartments near Oberhaus Park. Located within easy reach of this local oasis, our community offers a tranquil setting with the convenience of nearby attractions.\n\nWith pet-friendly policies, central air and heating, and convenient laundry facilities in each building, Glen Arbors is designed for comfortable living. Situated at the end of a peaceful dead-end road, our apartments provide a serene escape while ensuring you’re moments away from Oberhaus Park. Discover comfort and convenience at Glen Arbors in Henry County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Glen Arbors Apts Near Oberhaus Park, Henry County",
      "seo_description": "Choose Glen Arbors in Henry County for apartments near Oberhaus Park. Enjoy ease and tranquility in our community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12067681992"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5685514"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJQ37FNV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_tax_credit_properties",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InB5OHk3RjBQeHhPeUhDMHluN0dYTXc9PSIsInZhbHVlIjoicXdKY1BuUmprUFoyUWpmaUZNclc5UT09IiwibWFjIjoiZjZhOGMxYTgwYWUxYzk1ZGMzNDViNjUwODY0NzFmNWMxOWE1YjgwNTA4NTVjZDkzMDliZjhhYjI1ZjdjZGRjMyJ9"
    }
  ],
  "custom_repli_id": "12067681992",
  "custom_realpage_id": "5685514",
  "custom_google_gtm_id": "GTM-PJQ37FNV",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Prestige",
  "custom_tax_credit_properties": "true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InB5OHk3RjBQeHhPeUhDMHluN0dYTXc9PSIsInZhbHVlIjoicXdKY1BuUmprUFoyUWpmaUZNclc5UT09IiwibWFjIjoiZjZhOGMxYTgwYWUxYzk1ZGMzNDViNjUwODY0NzFmNWMxOWE1YjgwNTA4NTVjZDkzMDliZjhhYjI1ZjdjZGRjMyJ9",
  "custom_audioeye_site_id": "3134695e-edb7-49fb-9121-70054ca94c2d",
  "custom_audioeye_site_hash": "26de8c42f185c2299658fac1f8c7e2a5"
};

export const generatedAt = '2026-09-23T21:47:48.856Z';
